import { Box, Paper, Tab, Tabs } from "@mui/material";
import React from "react";

import TabPanelFormat from "../../../../../components/widgets/TabPanelFormat";
import { getHashdata } from "../../PressureVessel/utils";
import { setHash } from "../../../../../components/Tabs/Utils/hashFunctions";
import { pvTabs } from "./PVTabs";
import { PVContext } from "./PV.Context";

export default function PVMain() {
  const { project, currentTab, setCurrentTab } = React.useContext(PVContext);
  // console.log("mcssss", project, currentTab);
  const tabs = pvTabs(project);

  const navLabel = "pv-modeling";

  const fullHash = window.location.hash;
  React.useEffect(() => {
    const hashValue = getHashdata(fullHash, navLabel);
    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue)
    );

    // console.log({ tabIndex });
    // if hash value for tabs is present, set it as currentTab
    if (tabIndex !== -1) {
      setCurrentTab(tabIndex);
    }
    // if its not present, but there is some existing hash value, add this to the hash value
    else if (fullHash)
      window.location.hash = fullHash + "&" + navLabel + "=" + tabs[0].label;
    // if not either, start a new hash
    else window.location.hash = navLabel + "=" + tabs[0].label;
  }, []);

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);

    setHash(fullHash, navLabel, tabs[newValue].label);
  };

  return (
    <Paper sx={{ width: "100%", display: "flex" }}>
      {/* <NavTabs
        tabs={tabs}
        // tabProps={verticalTabStyle}
        customCurrentTab={currentTab}
        setCustomCurrentTab={setCurrentTab}
        navLabel="mcs-tab"
        // vertical={true}
      /> */}

      <Box {...{ width: "100%", overflow: "auto" }}>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          orientation={"horizontal"}
        >
          {tabs.map((tab, i) => {
            return <Tab label={tab.label} value={i} />;
          })}
        </Tabs>

        <TabPanelFormat padding={0} {...tabs[currentTab].panelProps}>
          {tabs[currentTab].panel}
        </TabPanelFormat>
      </Box>
    </Paper>
  );
}
